import { BehaviorSubject, of, Subject, TimeInterval, timer } from 'rxjs';
import {
  distinctUntilChanged,
  mapTo,
  publishReplay,
  refCount,
  switchMap,
  timeInterval
} from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { LocalizePipe } from 'src/app/pipes/localize.pipe';
export interface SpinningEvent {
  spinning: boolean;
  title: string;
}

export const SHOW_TIME = 1000;

@Injectable({
  providedIn: 'root'
})
export class SpinnerOverlayService {
  private readonly localizePipe = inject(LocalizePipe);

  private spinnerEventSubject = new Subject<SpinningEvent>();
  private spinningRequests = 0;
  private title: string = undefined;
  public isCryptoPayment: boolean = false;
  public noSpinnerEvent$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public cancelCryptoPayment = new Subject<boolean>();

  private spinningForMinimumConfiguredAmountOfTime = this.spinnerEventSubject.pipe(
    distinctUntilChanged(),
    timeInterval(),
    switchMap((x: TimeInterval<SpinningEvent>) => {
      const timeLeft = Math.max(SHOW_TIME - x.interval, 0);
      return x.value.spinning
        ? of(this.getSpinningEvent(true))
        : timer(timeLeft).pipe(mapTo(this.getSpinningEvent(false)));
    }),
    publishReplay(1),
    refCount()
  );

  get spinningEvents() {
    return this.spinningForMinimumConfiguredAmountOfTime;
  }

  startSpinning() {
    this.spinningRequests++;
    this.noSpinnerEvent$.next(false);

    if (this.spinningRequests === 1) {
      this.spinnerEventSubject.next(this.getSpinningEvent(true));

      const parsedUrl = new URL(window.location.href);
      const isEmbed = parsedUrl.searchParams.get('PinbordButtonEmbed');

      if (isEmbed) {
        const blocker = document.getElementById('PbBlocker');
        const loader = document.getElementById('loaderForPb');

        if (blocker) blocker.remove();
        if (loader) loader.remove();
      }
    }
  }

  stopSpinning() {
    if (this.spinningRequests <= 0) {
      this.spinningRequests = 0;
      return;
    }

    this.spinningRequests--;

    if (this.spinningRequests === 0) {
      this.spinnerEventSubject.next(this.getSpinningEvent(false));
    }
  }

  overrideTitle(title: string): void {
    this.title = title;
  }

  restoreDefaultTitle(): void {
    this.title = undefined;
  }

  cryptoSpinerEvent() {
    this.isCryptoPayment = true;
    this.spinnerEventSubject.next(this.getSpinningEvent(true));
  }

  private getSpinningEvent(spinning?: boolean) {
    this.title = this.localizePipe.transform('spinnerTitle')
      ? this.localizePipe.transform('spinnerTitle')
      : this.title;
    return {
      spinning: spinning !== undefined ? spinning : this.spinningRequests > 0,
      title: this.title,
      isCryptoPayment: this.isCryptoPayment
    };
  }

  public get spinningRequest(): number {
    return this.spinningRequests;
  }
}
